import styled from "styled-components";
import { Navigation } from "swiper";
import { Grid } from "antd-mobile";
import { FormattedMessage } from "react-intl";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import { date2block } from "../../../../utils/utils";

import Image from "../../../../components/Image";
import { useRef, forwardRef, useImperativeHandle } from "react";
import { useState } from "react";

export default forwardRef(CSwiper);
function CSwiper({ list = [], onClick, active }, ref) {
  const swiper = useRef();
  // const [active, setActive ] = useState(0)
  useImperativeHandle(ref, () => {
    return {
      getSwiper: () => {
        return swiper.current;
      },
    };
  });
  return (
    <SwiperContainer>
      <Swiper
        // observer={true}
        modules={[Navigation]}
        slidesPerView={5}
        direction={"vertical"}
        onSwiper={(s) => {
          swiper.current = s;
        }}
        onClick={(params) => {
          // swiper.current.activeIndex= params.clickedIndex
          onClick(params.clickedIndex);
        }}
        navigation={{
          nextEl: ".swiper-button-next2",
          prevEl: ".swiper-button-prev2",
        }}
      >
        {list.map((e, i) => {
          return e ? (
            <SwiperSlide key={e.id || i}>
              <ItemWrapper active={active === i}>
                <Item style={{ transform: e.img ? "rotate(-25deg)" : "" }}>
                  <Image
                    width={e.img ? "5.0rem" : "4.0rem"}
                    src={e.img || "image/icons/icon5.png"}
                    fit={"contain"}
                    alt={"icon5"}
                    key={"icon5"}
                  />
                </Item>
              </ItemWrapper>
              {/* <Divider /> */}
            </SwiperSlide>
          ) : null;
        })}
        {/* <div className="swiper-button-prev">
          <img src="/image/left_arrow.png" width={25} alt="left_arrow" />
        </div> */}
      </Swiper>
      <div className="swiper-button-next2">
        <img src="/image/icons/icon19.png" width={20} alt="right_arrow" />
      </div>
    </SwiperContainer>
  );
}

const SwiperContainer = styled.div`
  height: 100%;
  padding-bottom: 5rem;
  box-sizing: border-box;
  position: relative;
  .swiper {
    width: 100%;
    height: 100%;
    position: relative;
    .swiper-button-prev2 {
      left: 1rem;
      right: auto;
      position: absolute;
      top: 8.1rem;
      z-index: 10;
      transform: translateY(-50%);
    }

    .swiper-button-disabled {
      opacity: 0.5;
    }
    /* .swiper-slide {
      padding: 4.1rem 0 0;
    } */
  }
  .swiper-button-next2 {
    right: auto;
    left: 2rem;
    position: absolute;
    bottom: 2rem;
    z-index: 10;
  }
`;

const ItemWrapper = styled.div`
  background-color: ${(props) => (props.active ? "#fff" : "")};
  border-top-left-radius: 2rem;
  border-bottom-left-radius: 2rem;

  position: relative;
  &:after {
    content: "";
    position: absolute;
    left: 1.1rem;
    bottom: -3px;
    /* border: ..5rem solid #C4C4C4; */
    width: 4.2rem;
  }
`;

const Item = styled.div`
  width: 6rem;
  height: 6rem;
  .rv-image {
    margin: auto;
  }
`;
